import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TermsAndConditions from '../TermsAndConditions';
import { useSiteContent } from '../../hooks/useSiteContent';
import AvailabilitySummary from './AvailabilitySummary';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/subjects', label: 'Subjects' },
  { to: '/oxbridge', label: 'Oxbridge' },
  { to: '/contact', label: 'Contact' },
];

const Footer: React.FC = () => {
  const c = useSiteContent();
  const [showTerms, setShowTerms] = useState(false);
  const year = new Date().getFullYear();

  return (
    <>
      <footer className="mt-24 bg-navy text-cream">
        <div className="container-content py-16">
          <div className="grid md:grid-cols-3 gap-10 md:gap-16">
            <div>
              <Link to="/" className="flex items-center gap-3 no-underline text-cream hover:text-cream">
                <img src="/ejl-logo.png" alt="" className="w-9 h-9 object-contain" />
                <span className="font-serif text-[19px] text-cream">
                  {c('footer_brand', 'EJL Education')}
                </span>
              </Link>
              <p className="mt-5 text-[15px] text-cream/80 leading-relaxed">
                {c('footer_blurb', "One-to-one tutoring for 11+, GCSE, A-level and Oxbridge applicants. Run by Ethan Langley, Wilson's School.")}
              </p>
            </div>

            <nav aria-label="Footer">
              <h3 className="font-serif text-[18px] text-cream mb-4">Pages</h3>
              <ul className="space-y-2">
                {NAV.map(item => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-[15px] text-cream/80 hover:text-ochre no-underline">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            <div>
              <h3 className="font-serif text-[18px] text-cream mb-4">
                {c('footer_hours_h', 'Availability')}
              </h3>
              <AvailabilitySummary variant="footer" />
              <p className="mt-4 text-[13px] text-cream/60">
                {c('footer_safeguarding', 'DBS-checked. Certificate available on request.')}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-cream/10">
          <div className="container-content py-5 flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-[13px] text-cream/60">© {year} EJL Education. All rights reserved.</p>
            <button
              onClick={() => setShowTerms(true)}
              className="text-[13px] text-cream/70 hover:text-ochre underline-offset-4 hover:underline"
            >
              Terms and conditions
            </button>
          </div>
        </div>
      </footer>
      <TermsAndConditions isOpen={showTerms} onClose={() => setShowTerms(false)} />
    </>
  );
};

export default Footer;
